import { IconButton } from '@material-ui/core';
import { Close as IconClose } from '@material-ui/icons';
import type { SnackbarKey } from 'notistack';
import { useSnackbar } from 'notistack';
import * as React from 'react';

interface SnackbarCloseButtonProps {
  closeKey?: SnackbarKey | undefined;
}

const SnackbarCloseButton: React.FC<SnackbarCloseButtonProps> = ({ closeKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      aria-label="Close notification"
      color="inherit"
      onClick={() => closeSnackbar(closeKey)}
    >
      <IconClose />
    </IconButton>
  );
};

export default SnackbarCloseButton;
